import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Icon, Spinner, Select } from "components/common";
import { useStore } from "stores/connect";
import { Input, Button } from "components/bootstrap";
import InputProfilesStore, { InputProfilesActions } from "forwarder/stores/InputProfilesStore";
const StyledIcon = styled(Icon)`
  margin-right: 0.5em;
`;
const SelectWrapper = styled("div")`
  margin: 1em 0;
`;
const InputProfileSelectionList = ({ onInputProfileSelect, maxRadio = 6 }) => {
  const [selectedInputProfile, setSelectedInputProfile] = useState();
  const { all: inputProfiles } = useStore(InputProfilesStore);
  useEffect(() => {
    InputProfilesActions.listAll();
  }, []);
  if (!inputProfiles) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Input Profiles..." }));
  }
  const _selectProfile = (id) => {
    const selectedProfile = inputProfiles.find((inputProfile) => inputProfile.id === id);
    if (selectedProfile === void 0) {
      throw new Error("Selected Input Profile is not in the list of Input Profiles.");
    }
    setSelectedInputProfile(selectedProfile);
  };
  const handleRadioSelection = (event) => {
    const { value: id } = event.target;
    _selectProfile(id);
  };
  const handleSelectChange = _selectProfile;
  const handleInputProfileSelect = (event) => {
    event.preventDefault();
    if (selectedInputProfile) {
      onInputProfileSelect(selectedInputProfile);
    }
  };
  return /* @__PURE__ */ React.createElement("form", { onSubmit: handleInputProfileSelect }, /* @__PURE__ */ React.createElement("div", null, inputProfiles.length === 0 && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "info" }), " There are no Input Profiles yet."), inputProfiles.length > 0 && inputProfiles.length <= maxRadio && inputProfiles.map((inputProfile) => /* @__PURE__ */ React.createElement(
    Input,
    {
      key: inputProfile.id,
      id: inputProfile.id,
      type: "radio",
      name: "inputProfile",
      value: inputProfile.id,
      label: inputProfile.title,
      onChange: handleRadioSelection
    }
  )), inputProfiles.length > 0 && inputProfiles.length > maxRadio && /* @__PURE__ */ React.createElement(SelectWrapper, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      name: "inputProfile",
      placeholder: "Select Input Profile...",
      onChange: handleSelectChange,
      options: inputProfiles.map((inputProfile) => ({ label: inputProfile.title, value: inputProfile.id }))
    }
  ))), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: selectedInputProfile === void 0 }, "Finish configuration"));
};
export default InputProfileSelectionList;
